module.exports = __webpack_public_path__ + "media/components/shared/images/PaymentMethodStripeJpy-1aba623b0dcdfdf5cf1dfd0cddcbe462.png";